import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpMethodPattern } from './url-match';
import { MockDef } from './mock-registry';
import { RequestLogEntry } from './request-log';
import { mockRegistry, requestLog } from './dev-mock-store';

@Component({
  selector: 'ps20-shop-dev-mock-panel',
  templateUrl: './dev-mock-panel.component.html',
  styleUrls: ['./dev-mock-panel.component.scss'],
  imports: [FormsModule],
})
export class DevMockPanelComponent {
  open = false;
  tab: 'mocks' | 'requests' = 'requests';

  fMethod: HttpMethodPattern = 'get';
  fUrl = '';
  fStatus = 200;
  fDelay = 0;
  fBody = '{}';
  jsonError: string | null = null;

  mocks(): MockDef[] {
    return mockRegistry.list();
  }

  requests(): RequestLogEntry[] {
    return requestLog.list();
  }

  saveMock(): void {
    try {
      JSON.parse(this.fBody);
    } catch {
      this.jsonError = 'Body is not valid JSON';
      return;
    }
    this.jsonError = null;
    mockRegistry.add({
      enabled: true,
      method: this.fMethod,
      urlPattern: this.fUrl,
      status: this.fStatus,
      delayMs: this.fDelay || undefined,
      body: this.fBody,
    });
  }

  mockThis(entry: RequestLogEntry): void {
    this.tab = 'mocks';
    this.fMethod = (entry.method.toLowerCase() as HttpMethodPattern) || 'get';
    try {
      this.fUrl = `*${new URL(entry.url).pathname}*`;
    } catch {
      this.fUrl = entry.url;
    }
    this.fStatus = entry.status || 200;
    this.fBody = entry.bodyText ?? '';
    this.jsonError = null;
  }

  toggle(id: string): void {
    mockRegistry.toggle(id);
  }

  remove(id: string): void {
    mockRegistry.remove(id);
  }

  clearLog(): void {
    requestLog.clear();
  }
}
